import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2686a709"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-chain-graph-wrap" }
const _hoisted_2 = { class: "graph-toolbar" }
const _hoisted_3 = {
  type: "button",
  class: "graph-toolbar__btn graph-toolbar__btn--legend"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-info",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down graph-toolbar__caret",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = { class: "legend-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1781590358659",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "72386",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M954.257 506.447C941.44 496.235 823.879 376.81 816.365 370.895c-9.374-7.388-18.862 2.006-18.862 14.637v105.301H64.212v61.108h733.291v105.242c0 13.914 10.486 20.67 18.477 14.554 10.916-8.339 129.051-128.371 138.277-135.863 8.276-6.716 8.416-22.716 0-29.427z",
    "p-id": "72387",
    style: {"fill":"var(--cm-color-text-secondary)"}
  })
], -1))
const _hoisted_8 = { class: "legend-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1781590280256",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "69867",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M692.5 521.1H566.9v-31.4h125.6v31.4z m-251.3 0H315.6v-31.4h125.6v31.4z m-251.3 0H64.3v-31.4h125.6v31.4z",
    fill: "#d81e06",
    "p-id": "69868"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M965.8 505.4L653.3 633.1l74.1-127.7-74.1-127.7z",
    fill: "#d81e06",
    "p-id": "69869"
  })
], -1))
const _hoisted_10 = { class: "legend-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1782381811415",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3343",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M67.89847538 492.58400192l582.47994501-1e-8L650.37842039 546.5173303 67.89847538 546.5173303l2e-8-53.93332839z",
    fill: "#67c23a",
    "p-id": "3344"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M647.09938542 331.19222266L960.7412301 515.39457616l-313.64184468 189.18079522 0-373.38314872z",
    fill: "#67c23a",
    "p-id": "3345"
  })
], -1))
const _hoisted_12 = { class: "legend-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "legend-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 32 32",
    width: "16",
    height: "16"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "6",
      y: "4",
      width: "20",
      height: "24",
      rx: "2",
      style: {"fill":"var(--cm-color-hover-bg)","stroke":"var(--cm-color-text-secondary)"},
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "10",
      y1: "11",
      x2: "22",
      y2: "11",
      style: {"stroke":"var(--cm-color-text-secondary)"},
      "stroke-width": "1.2"
    }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "10",
      y1: "16",
      x2: "20",
      y2: "16",
      style: {"stroke":"var(--cm-color-text-secondary)"},
      "stroke-width": "1.2"
    })
  ])
], -1))
const _hoisted_14 = { class: "legend-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1781590469772",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "72668",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 881.371429C303.542857 881.371429 142.628571 713.142857 142.628571 512S310.857143 142.628571 512 142.628571c208.457143 0 369.371429 168.228571 369.371429 369.371429S720.457143 881.371429 512 881.371429z m0-687.542858c-171.885714 0-314.514286 138.971429-314.514286 314.514286s138.971429 314.514286 314.514286 314.514286 314.514286-138.971429 314.514286-314.514286-142.628571-314.514286-314.514286-314.514286z",
    fill: "#d81e06",
    "p-id": "72669"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 888.685714C303.542857 888.685714 135.314286 720.457143 135.314286 512 135.314286 307.2 307.2 135.314286 512 135.314286c208.457143 0 376.685714 168.228571 376.685714 376.685714 0 208.457143-168.228571 376.685714-376.685714 376.685714z m0-738.742857c-197.485714 0-362.057143 164.571429-362.057143 362.057143 0 201.142857 160.914286 362.057143 362.057143 362.057143s362.057143-160.914286 362.057143-362.057143-160.914286-362.057143-362.057143-362.057143z m0 676.571429c-175.542857 0-321.828571-142.628571-321.828571-321.828572 0-175.542857 146.285714-318.171429 321.828571-318.171428s321.828571 142.628571 321.828571 321.828571c0 175.542857-146.285714 318.171429-321.828571 318.171429z m0-625.371429c-168.228571 0-307.2 138.971429-307.2 307.2 0 168.228571 138.971429 307.2 307.2 307.2s307.2-138.971429 307.2-307.2c0-171.885714-138.971429-307.2-307.2-307.2z",
    fill: "#d81e06",
    "p-id": "72670"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 987.428571c-18.285714 0-29.257143-10.971429-29.257143-29.257142v-76.8c0-18.285714 10.971429-29.257143 29.257143-29.257143s29.257143 10.971429 29.257143 29.257143v76.8c0 18.285714-10.971429 29.257143-29.257143 29.257142z m0-815.542857c-18.285714 0-29.257143-10.971429-29.257143-29.257143V65.828571c0-18.285714 10.971429-29.257143 29.257143-29.257142s29.257143 10.971429 29.257143 29.257142v76.8c0 18.285714-10.971429 29.257143-29.257143 29.257143zM142.628571 541.257143H65.828571c-18.285714 0-29.257143-10.971429-29.257142-29.257143s10.971429-29.257143 29.257142-29.257143h76.8c18.285714 0 29.257143 10.971429 29.257143 29.257143s-10.971429 29.257143-29.257143 29.257143z m815.542858 0h-76.8c-18.285714 0-29.257143-10.971429-29.257143-29.257143s10.971429-29.257143 29.257143-29.257143h76.8c18.285714 0 29.257143 10.971429 29.257142 29.257143s-10.971429 29.257143-29.257142 29.257143zM193.828571 859.428571c-7.314286 0-18.285714 0-21.942857-7.314285-10.971429-10.971429-10.971429-29.257143 0-40.228572l54.857143-54.857143c10.971429-10.971429 29.257143-10.971429 40.228572 0 10.971429 10.971429 10.971429 29.257143 0 40.228572l-54.857143 54.857143c-3.657143 0-7.314286 7.314286-18.285715 7.314285zM775.314286 277.942857c-7.314286 0-18.285714 0-21.942857-7.314286-10.971429-10.971429-10.971429-29.257143 0-40.228571l54.857142-54.857143c10.971429-10.971429 29.257143-10.971429 40.228572 0 10.971429 10.971429 10.971429 29.257143 0 40.228572l-54.857143 54.857142c-7.314286 7.314286-14.628571 7.314286-18.285714 7.314286z m-526.628572 0c-7.314286 0-18.285714 0-21.942857-7.314286L171.885714 215.771429c-10.971429-10.971429-10.971429-29.257143 0-40.228572s29.257143-10.971429 40.228572 0l54.857143 54.857143c10.971429 10.971429 10.971429 29.257143 0 40.228571 0 7.314286-7.314286 7.314286-18.285715 7.314286z m581.485715 581.485714c-7.314286 0-18.285714 0-21.942858-7.314285l-54.857142-54.857143c-10.971429-10.971429-10.971429-29.257143 0-40.228572 10.971429-10.971429 29.257143-10.971429 40.228571 0l54.857143 54.857143c10.971429 10.971429 10.971429 29.257143 0 40.228572-7.314286 0-10.971429 7.314286-18.285714 7.314285z",
    fill: "#d81e06",
    "p-id": "72671"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 994.742857c-21.942857 0-36.571429-14.628571-36.571429-36.571428v-76.8c0-21.942857 14.628571-36.571429 36.571429-36.571429s36.571429 14.628571 36.571429 36.571429v76.8c0 21.942857-14.628571 36.571429-36.571429 36.571428z m0-135.314286c-10.971429 0-21.942857 7.314286-21.942857 21.942858v76.8c0 10.971429 7.314286 21.942857 21.942857 21.942857s21.942857-7.314286 21.942857-21.942857v-76.8c0-14.628571-10.971429-21.942857-21.942857-21.942858z m318.171429 7.314286c-7.314286 0-18.285714 0-29.257143-7.314286L746.057143 804.571429c-14.628571-14.628571-14.628571-36.571429 0-51.2 14.628571-14.628571 36.571429-14.628571 51.2 0l54.857143 54.857142c14.628571 14.628571 14.628571 36.571429 0 51.2l-3.657143 3.657143h-3.657143s-3.657143 0-3.657143 3.657143c-3.657143-3.657143-7.314286 0-10.971428 0z m-58.514286-109.714286c-3.657143 0-10.971429 3.657143-14.628572 7.314286-7.314286 7.314286-7.314286 21.942857 0 29.257143l54.857143 54.857143c3.657143 3.657143 14.628571 3.657143 18.285715 3.657143 0 0 3.657143 0 3.657142-3.657143 3.657143 0 3.657143-3.657143 7.314286-3.657143 7.314286-7.314286 7.314286-18.285714 0-25.6l-54.857143-54.857143c-3.657143-3.657143-7.314286-7.314286-14.628571-7.314286z m-577.828572 109.714286c-7.314286 0-18.285714 0-29.257142-7.314286-7.314286-7.314286-10.971429-14.628571-10.971429-25.6s3.657143-18.285714 10.971429-25.6L219.428571 753.371429c14.628571-14.628571 36.571429-14.628571 51.2 0 7.314286 7.314286 10.971429 14.628571 10.971429 25.6s-3.657143 18.285714-10.971429 25.6l-54.857142 54.857142s-7.314286 7.314286-21.942858 7.314286z m51.2-109.714286c-3.657143 0-10.971429 3.657143-14.628571 7.314286l-54.857143 54.857143c-3.657143 3.657143-7.314286 7.314286-7.314286 14.628571s3.657143 10.971429 7.314286 14.628572c3.657143 3.657143 14.628571 3.657143 18.285714 3.657143 7.314286 0 10.971429-3.657143 10.971429-3.657143l54.857143-54.857143c3.657143-3.657143 7.314286-7.314286 7.314286-14.628571s-3.657143-10.971429-7.314286-14.628572c-3.657143-3.657143-7.314286-7.314286-14.628572-7.314286zM958.171429 548.571429h-76.8c-21.942857 0-36.571429-14.628571-36.571429-36.571429s14.628571-36.571429 36.571429-36.571429h76.8c21.942857 0 36.571429 14.628571 36.571428 36.571429s-14.628571 36.571429-36.571428 36.571429z m-76.8-58.514286c-10.971429 0-21.942857 7.314286-21.942858 21.942857s7.314286 21.942857 21.942858 21.942857h76.8c10.971429 0 21.942857-7.314286 21.942857-21.942857s-7.314286-21.942857-21.942857-21.942857h-76.8zM142.628571 548.571429H65.828571c-21.942857 0-36.571429-14.628571-36.571428-36.571429s14.628571-36.571429 36.571428-36.571429h76.8c21.942857 0 36.571429 14.628571 36.571429 36.571429s-14.628571 36.571429-36.571429 36.571429z m-76.8-58.514286c-10.971429 0-21.942857 7.314286-21.942857 21.942857s7.314286 21.942857 21.942857 21.942857h76.8c10.971429 0 21.942857-7.314286 21.942858-21.942857s-7.314286-21.942857-21.942858-21.942857H65.828571z m709.485715-204.8c-7.314286 0-18.285714 0-29.257143-7.314286-14.628571-14.628571-14.628571-36.571429 0-51.2L804.571429 171.885714c14.628571-14.628571 36.571429-14.628571 51.2 0 7.314286 7.314286 10.971429 14.628571 10.971428 25.6s-7.314286 18.285714-14.628571 21.942857l-54.857143 54.857143c-7.314286 10.971429-14.628571 10.971429-21.942857 10.971429z m51.2-109.714286c-3.657143 0-10.971429 3.657143-14.628572 7.314286l-54.857143 54.857143c-7.314286 7.314286-7.314286 21.942857 0 29.257143 3.657143 3.657143 14.628571 3.657143 18.285715 3.657142 7.314286 0 7.314286 0 10.971428-3.657142L841.142857 212.114286c3.657143-3.657143 7.314286-7.314286 7.314286-14.628572s-3.657143-10.971429-7.314286-14.628571c-3.657143-3.657143-7.314286-7.314286-14.628571-7.314286z m-577.828572 109.714286c-7.314286 0-18.285714 0-29.257143-7.314286L164.571429 219.428571c-14.628571-14.628571-14.628571-36.571429 0-51.2 14.628571-14.628571 36.571429-14.628571 51.2 0l54.857142 54.857143c7.314286 7.314286 10.971429 14.628571 10.971429 25.6 0 7.314286-3.657143 14.628571-7.314286 21.942857-3.657143 14.628571-14.628571 14.628571-25.6 14.628572z m-58.514285-109.714286c-3.657143 0-10.971429 3.657143-14.628572 7.314286-7.314286 7.314286-7.314286 21.942857 0 29.257143l54.857143 54.857143c3.657143 3.657143 14.628571 3.657143 18.285714 3.657142h10.971429l3.657143-3.657142c0-3.657143 3.657143-10.971429 3.657143-14.628572s-3.657143-10.971429-7.314286-14.628571L204.8 182.857143c-3.657143-3.657143-10.971429-7.314286-14.628571-7.314286z m321.828571 3.657143c-21.942857 0-36.571429-14.628571-36.571429-36.571429V65.828571c0-21.942857 14.628571-36.571429 36.571429-36.571428s36.571429 14.628571 36.571429 36.571428v76.8c0 21.942857-14.628571 36.571429-36.571429 36.571429z m0-135.314286c-10.971429 0-21.942857 7.314286-21.942857 21.942857v76.8c0 10.971429 7.314286 21.942857 21.942857 21.942858s21.942857-7.314286 21.942857-21.942858V65.828571c0-14.628571-10.971429-21.942857-21.942857-21.942857z",
    fill: "#d81e06",
    "p-id": "72672"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M340.114286 416.914286c0 29.257143 14.628571 54.857143 40.228571 69.485714s54.857143 14.628571 76.8 0c25.6-14.628571 40.228571-40.228571 40.228572-69.485714 0-29.257143-14.628571-54.857143-40.228572-69.485715-25.6-14.628571-54.857143-14.628571-76.8 0s-40.228571 40.228571-40.228571 69.485715z",
    fill: "#d81e06",
    "p-id": "72673"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M416.914286 501.028571c-14.628571 0-29.257143-3.657143-43.885715-10.971428-25.6-14.628571-43.885714-43.885714-43.885714-73.142857s14.628571-58.514286 43.885714-73.142857c29.257143-14.628571 58.514286-14.628571 87.771429 0 25.6 14.628571 43.885714 43.885714 43.885714 73.142857s-14.628571 58.514286-43.885714 73.142857c-14.628571 7.314286-29.257143 10.971429-43.885714 10.971428z m0-153.6c-10.971429 0-25.6 3.657143-36.571429 10.971429-21.942857 10.971429-36.571429 36.571429-36.571428 62.171429s14.628571 47.542857 36.571428 62.171428c21.942857 10.971429 47.542857 10.971429 69.485714 0 21.942857-10.971429 36.571429-36.571429 36.571429-62.171428s-14.628571-47.542857-36.571429-62.171429c-7.314286-10.971429-21.942857-10.971429-32.914285-10.971429z",
    fill: "#d81e06",
    "p-id": "72674"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M596.114286 501.028571c0 29.257143 21.942857 51.2 51.2 51.2 29.257143 0 51.2-21.942857 51.2-51.2 0-29.257143-21.942857-51.2-51.2-51.2-29.257143 0-51.2 21.942857-51.2 51.2z",
    fill: "#d81e06",
    "p-id": "72675"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M647.314286 559.542857c-32.914286 0-58.514286-25.6-58.514286-58.514286s25.6-58.514286 58.514286-58.514285 58.514286 25.6 58.514285 58.514285-29.257143 58.514286-58.514285 58.514286z m0-102.4c-21.942857 0-43.885714 18.285714-43.885715 43.885714 0 21.942857 18.285714 43.885714 43.885715 43.885715 21.942857 0 43.885714-18.285714 43.885714-43.885715-3.657143-25.6-21.942857-43.885714-43.885714-43.885714z",
    fill: "#d81e06",
    "p-id": "72676"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M398.628571 636.342857c0 21.942857 18.285714 40.228571 40.228572 40.228572s40.228571-18.285714 40.228571-40.228572c0-21.942857-18.285714-40.228571-40.228571-40.228571s-40.228571 18.285714-40.228572 40.228571z",
    fill: "#d81e06",
    "p-id": "72677"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M438.857143 680.228571c-25.6 0-47.542857-21.942857-47.542857-47.542857 0-25.6 21.942857-47.542857 47.542857-47.542857s47.542857 21.942857 47.542857 47.542857c0 29.257143-21.942857 47.542857-47.542857 47.542857z m0-76.8c-18.285714 0-32.914286 14.628571-32.914286 32.914286s14.628571 32.914286 32.914286 32.914286 32.914286-14.628571 32.914286-32.914286-14.628571-32.914286-32.914286-32.914286z",
    fill: "#d81e06",
    "p-id": "72678"
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "graph-toolbar__divider",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_17 = { class: "graph-toolbar__actions" }
const _hoisted_18 = ["title"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-zoom-in",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["title"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-zoom-out",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["title"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-refresh",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["title"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-refresh-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 0,
  class: "graph-asset-badge"
}
const _hoisted_31 = { class: "graph-asset-badge__label" }
const _hoisted_32 = { class: "graph-asset-badge__ip" }

import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import G6 from '@antv/g6'
import { handleDataToTree } from '@/utils/tool'
import type { ProcessChainNode } from '../types'
import { ISO_NODE_SIZE, PROCESS_CHAIN_EDGE_STYLE, registerIsoProcessChainShapes, linkProcessChainGraph } from './process-chain-iso'

type G6TreeNode = {
  id: string
  label: string
  type: string
  raw: ProcessChainNode & { children?: ProcessChainNode[] }
  children: G6TreeNode[]
  edgeLabel?: string
  roleLabel?: string
  threatEntityLabel?: string
  eventLevel?: number
  /** 是否匹配列表行 business_id，用于绘制右上角标记 */
  isBusinessIdMatch?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'process-chain-graph',
  props: {
    nodes: {},
    selectedId: {},
    assetIp: {},
    computer_name: {},
    fullscreen: { type: Boolean },
    eventLevel: {},
    matchedBusinessId: {}
  },
  emits: ["nodeClick", "nodeMoreClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()

const containerRef = ref<HTMLElement>()
const minimapRef = ref<HTMLElement>()
let graph: G6.TreeGraph | null = null
let resizeObserver: ResizeObserver | null = null

registerIsoProcessChainShapes()

/** business_id 匹配的所有节点 ID 集合 */
const matchedNodeIds = computed(() => {
  const ids = new Set<string>()
  if (!props.matchedBusinessId || !props.nodes.length) return ids
  props.nodes.forEach((n) => {
    if (n.business_id === props.matchedBusinessId) ids.add(n.id)
  })
  return ids
})

const normalLegendLineStyle = {
  '--legend-line-color': PROCESS_CHAIN_EDGE_STYLE.normal.stroke,
  '--legend-line-width': `${PROCESS_CHAIN_EDGE_STYLE.normal.lineWidth}px`,
}

const keyPathLegendLineStyle = {
  '--legend-line-color': PROCESS_CHAIN_EDGE_STYLE.keyPath.stroke,
  '--legend-line-width': `${PROCESS_CHAIN_EDGE_STYLE.keyPath.lineWidth}px`,
  '--legend-line-dash-segment': `${PROCESS_CHAIN_EDGE_STYLE.keyPath.lineDash[0]}px`,
  '--legend-line-dash-gap': `${PROCESS_CHAIN_EDGE_STYLE.keyPath.lineDash[1]}px`,
}

/**
 * 画布交互行为：始终可拖拽；仅全屏模式下允许滚轮缩放，
 * 非全屏时去掉 zoom-canvas，滚轮事件透传给抽屉滚动页面。
 */
function getInteractionModes (): string[] {
  const modes = ['drag-canvas']
  if (props.fullscreen) modes.push('zoom-canvas')
  return modes
}

/**
 * 使用 handleDataToTree 将扁平节点转为树结构（参考 data-discovery.vue 模式）。
 * parent_id === '0' 或 !parent_id 的节点自动成为根节点。
 * 若存在多个根节点，用 __root__ 包裹。
 */
function buildTreeFromFlatData (
  nodes: ProcessChainNode[]
): (ProcessChainNode & { children?: ProcessChainNode[] }) | null {
  if (!nodes.length) return null
  // 浅拷贝每个节点，避免 handleDataToTree 在原 reactive 对象上添加 children 属性触发 deep watcher 死循环
  const cloned = nodes.map((n) => ({ ...n }))
  const trees = handleDataToTree(cloned as any, undefined, 'parent_id') as (ProcessChainNode & { children?: ProcessChainNode[] })[]
  if (!trees.length) return null
  if (trees.length === 1) return trees[0]
  // 多根节点：合成虚拟根节点
  return { id: '__root__', name: 'root', children: trees } as ProcessChainNode & { children?: ProcessChainNode[] }
}

function displayText (value?: string): string {
  if (!value) return ''
  return value.startsWith('securityEvent.') ? t(value) : value
}

function toG6Node (node: ProcessChainNode & { children?: ProcessChainNode[] }): G6TreeNode {
  const name = displayText(node.name)
  const label = name.length > 16 ? `${name.slice(0, 15)}…` : name
  const roleLabel =
    node.node_type === 2
      ? t('securityEvent.roleInitiator')
      : node.node_type === 3
        ? t('securityEvent.roleTarget')
        : ''
  const threatEntityLabel = node.is_threat_entity === 1 ? t('securityEvent.colThreatEntity') : ''
  const isBusinessIdMatch = matchedNodeIds.value.has(node.id)
  return {
    id: node.id,
    label,
    type: 'iso-process-node',
    raw: node,
    children: (node.children || []).map((c) => toG6Node(c)),
    roleLabel,
    threatEntityLabel,
    eventLevel: props.eventLevel,
    isBusinessIdMatch,
  }
}

function attachEdgeLabels (data: G6TreeNode): G6TreeNode {
  const visit = (node: G6TreeNode) => {
    if (!node.children?.length) return
    node.children.forEach((child) => {
      if (child.raw?.action_label) {
        child.edgeLabel = displayText(child.raw.action_label)
      }
      visit(child)
    })
  }
  visit(data)
  return data
}

function bindGraphEvents () {
  if (!graph) return
  graph.off('node:click')
  graph.on('node:click', (evt: { item?: { getModel: () => Record<string, unknown> }; target?: { get: (k: string) => string } }) => {
    const model = evt.item?.getModel?.() as { id?: string; raw?: ProcessChainNode }
    if (!model?.raw || model.id === '__root__') return
    // 检测是否点击了"更多"按钮
    const targetName = evt.target?.get?.('name')
    if (targetName === 'more-btn-bg' || targetName === 'more-btn-icon') {
      emit('nodeMoreClick', model.raw)
      return
    }
    emit('nodeClick', model.raw)
    highlightSelected(model.id)
  })
}

function highlightSelected (activeId?: string) {
  if (!graph) return
  const id = activeId ?? props.selectedId
  graph.getNodes().forEach((node) => {
    const model = node.getModel() as { id?: string }
    const active = !!id && model.id === id
    graph!.setItemState(node, 'selected', active)
  })
}

function resolveNodeId (edgeEnd: unknown): string {
  return String(edgeEnd).split(':').pop() || ''
}

function isKeyPathEdge (sourceId: string, targetId: string): boolean {
  const source = props.nodes.find((n) => n.id === sourceId)
  const target = props.nodes.find((n) => n.id === targetId)
  if (!source && !target) return false
  const isInitiatorToTarget = source?.node_type === 2 && target?.node_type === 3
  return !!(
    isInitiatorToTarget ||
    target?.is_threat ||
    target?.is_suspicious ||
    target?.node_role === 'network' ||
    target?.is_threat_entity === 1 ||
    source?.is_threat ||
    source?.is_suspicious ||
    source?.is_threat_entity === 1
  )
}

function getEdgeLabel (targetId: string): string {
  const target = props.nodes.find((n) => n.id === targetId)
  return displayText(target?.action_label || target?.behavior)
}

function hasTreeEdge (sourceId: string, targetId: string): boolean {
  const target = props.nodes.find((n) => n.id === targetId)
  return target?.parent_id === sourceId
}

/**
 * 获取所有匹配节点到根节点的路径边并集（黄色路径，不随点击变化）
 * 每个匹配节点沿 parent_id 向上追溯到根，所有路径取并集
 */
function getRootPathEdgeKeys (): Set<string> {
  const keys = new Set<string>()
  if (matchedNodeIds.value.size === 0) return keys

  for (const id of matchedNodeIds.value) {
    let currentNode = props.nodes.find((n) => n.id === id)
    while (currentNode) {
      const parentId = currentNode.parent_id
      if (!parentId || parentId === '0' || parentId === '__root__') break
      keys.add(`${parentId}->${currentNode.id}`)
      currentNode = props.nodes.find((n) => n.id === parentId) ?? undefined
    }
  }
  return keys
}

/**
 * 应用根路径边样式（黄色，优先级最高）
 * 更新已渲染边的视觉属性，避免重建整个图
 */
function applyRootPathEdgeStyles () {
  if (!graph) return
  const rootPathKeys = getRootPathEdgeKeys()

  graph.getEdges().forEach((edge: any) => {
    const model = edge.getModel()
    const sourceId = resolveNodeId(model.source)
    const targetId = resolveNodeId(model.target)
    const edgeKey = `${sourceId}->${targetId}`
    const isRootPath = rootPathKeys.has(edgeKey)

    const container = edge.getContainer()
    // 根据边类型查找路径 shape（不同边类型使用不同的 shape name）
    const pathShape = container.find((el: any) =>
      ['edge-path', 'threat-edge-path', 'root-path-edge'].includes(el.get('name'))
    )
    if (!pathShape) return

    if (isRootPath) {
      const style = PROCESS_CHAIN_EDGE_STYLE.rootPath
      pathShape.attr('stroke', style.stroke)
      pathShape.attr('lineWidth', style.lineWidth)
      pathShape.attr('lineDash', style.lineDash || null)
      // 绿色阴影
      pathShape.attr('shadowColor', 'rgba(103, 194, 58, 0.35)') // dm-keep
      pathShape.attr('shadowBlur', 8)
      pathShape.attr('shadowOffsetX', 0)
      pathShape.attr('shadowOffsetY', 0)
      // 更新箭头颜色
      const currentAttrs = pathShape.attr()
      if (currentAttrs.endArrow) {
        pathShape.attr('endArrow', {
          ...currentAttrs.endArrow,
          fill: style.stroke,
        })
      }
    } else {
      const isKeyPath = isKeyPathEdge(sourceId, targetId)
      const style = isKeyPath ? PROCESS_CHAIN_EDGE_STYLE.keyPath : PROCESS_CHAIN_EDGE_STYLE.normal
      pathShape.attr('stroke', style.stroke)
      pathShape.attr('lineWidth', style.lineWidth)
      pathShape.attr('lineDash', style.lineDash || null)
      // 清除阴影
      pathShape.attr('shadowColor', 'transparent')
      pathShape.attr('shadowBlur', 0)
      pathShape.attr('shadowOffsetX', 0)
      pathShape.attr('shadowOffsetY', 0)
      const currentAttrs = pathShape.attr()
      if (currentAttrs.endArrow) {
        pathShape.attr('endArrow', {
          ...currentAttrs.endArrow,
          fill: style.stroke,
        })
      }
    }
  })
}

/**
 * 构建节点后代映射表（传递闭包）
 * 通过 parent_id 关系计算出每个节点的所有子孙节点 ID 集合
 */
function buildDescendantMap (nodes: ProcessChainNode[]): Map<string, Set<string>> {
  const childrenMap = new Map<string, Set<string>>()
  nodes.forEach((n) => {
    const pid = n.parent_id
    if (pid && pid !== '0') {
      if (!childrenMap.has(pid)) childrenMap.set(pid, new Set())
      childrenMap.get(pid)!.add(n.id)
    }
  })

  const descendantMap = new Map<string, Set<string>>()
  function collectDescendants (nodeId: string): Set<string> {
    if (descendantMap.has(nodeId)) return descendantMap.get(nodeId)!
    const result = new Set<string>()
    const children = childrenMap.get(nodeId)
    if (children) {
      children.forEach((childId) => {
        result.add(childId)
        collectDescendants(childId).forEach((id) => result.add(id))
      })
    }
    descendantMap.set(nodeId, result)
    return result
  }

  nodes.forEach((n) => collectDescendants(n.id))
  return descendantMap
}

function renderInitiatorTargetEdges () {
  if (!graph) return

  // 清理旧的发起者→目标跨边（图不再销毁重建，需手动移除避免重复）
  graph.getEdges().forEach((edge) => {
    const model = edge.getModel()
    if (model.id && String(model.id).startsWith('initiator-target-')) {
      graph!.removeItem(edge)
    }
  })

  // 发起者（node_type=2）和威胁实体（is_threat_entity=1）作为攻击源
  const sources = props.nodes.filter((n) => n.node_type === 2 || n.is_threat_entity === 1)
  const targets = props.nodes.filter((n) => n.node_type === 3)

  // 构建后代映射：每个发起者只连接其攻击链子树内的目标
  const descendantMap = buildDescendantMap(props.nodes)

  sources.forEach((source) => {
    const descendants = descendantMap.get(source.id) ?? new Set()
    targets.forEach((target) => {
      // 只连接该发起者子树内的目标，避免跨链串联
      if (!descendants.has(target.id)) return
      if (source.id === target.id || hasTreeEdge(source.id, target.id)) return
      const sourceItem = graph!.findById(source.id)
      const targetItem = graph!.findById(target.id)
      if (!sourceItem || !targetItem) return
      graph!.addItem('edge', {
        id: `initiator-target-${source.id}-${target.id}`,
        source: source.id,
        target: target.id,
        type: 'iso-threat-edge',
        edgeLabel: getEdgeLabel(target.id),
      })
    })
  })
}

function fitViewSafe () {
  if (!graph) return
  graph.fitView(24)
  const zoom = graph.getZoom()
  if (zoom > 1) {
    graph.zoomTo(1, { x: graph.getWidth() / 2, y: graph.getHeight() / 2 }, true)
  } else if (zoom < 0.45) {
    graph.zoomTo(0.45, { x: graph.getWidth() / 2, y: graph.getHeight() / 2 }, true)
  }
}

function resizeGraph () {
  if (!graph || !containerRef.value) return
  const w = containerRef.value.clientWidth || 400
  const h = containerRef.value.clientHeight || 474
  if (w > 0 && h > 0) {
    graph.changeSize(w, h)
    fitViewSafe()
  }
}

function zoom (ratio: number) {
  if (!graph) return
  const center = graph.getGraphCenterPoint()
  graph.zoom(ratio, center, true)
}

function fitView () {
  fitViewSafe()
}

function resetView () {
  if (!graph) return
  graph.zoomTo(1, { x: graph.getWidth() / 2, y: graph.getHeight() / 2 }, true)
  fitViewSafe()
}

/**
 * 命令式刷新图数据（销毁重建，保证树根变化时正确渲染）
 * 参考 data-discovery.vue 的命令式更新模式，由父组件在修改 displayNodes 后调用
 */
function refreshGraph (nodes?: ProcessChainNode[]) {
  const data = nodes ?? props.nodes
  if (!containerRef.value || !data.length) return

  graph?.destroy()
  graph = null

  const treeData = buildTreeFromFlatData(data)
  if (!treeData) return

  const w = containerRef.value.clientWidth || 400
  const h = containerRef.value.clientHeight || 474

  const minimap = new G6.Minimap({
    container: minimapRef.value,
    size: [128, 80],
    type: 'keyShape',
  })

  graph = new G6.TreeGraph({
    container: containerRef.value,
    width: w,
    height: h,
    fitView: true,
    fitViewPadding: 24,
    minZoom: 0.35,
    maxZoom: 1.2,
    modes: { default: getInteractionModes() },
    defaultNode: {
      type: 'iso-process-node',
      size: ISO_NODE_SIZE,
    },
    defaultEdge: {
      type: 'iso-tree-edge',
    },
    layout: {
      type: 'compactBox',
      direction: 'LR',
      getId: (d: { id: string }) => d.id,
      getHeight: () => ISO_NODE_SIZE[1] + 16,
      getWidth: () => ISO_NODE_SIZE[0] + 24,
      getVGap: () => 28,
      getHGap: () => 100,
    },
    plugins: [minimap],
  })

  linkProcessChainGraph(graph)

  graph.edge((edge) => {
    const sourceId = resolveNodeId(edge.source)
    const targetId = resolveNodeId(edge.target)
    const edgeKey = `${sourceId}->${targetId}`
    const rootPathKeys = getRootPathEdgeKeys()
    if (rootPathKeys.has(edgeKey)) {
      const isKeyPath = isKeyPathEdge(sourceId, targetId)
      return {
        type: 'iso-root-path-edge',
        edgeLabel: getEdgeLabel(targetId),
        tagColor: isKeyPath ? '#e54545' : undefined,
      }
    }
    return {
      type: isKeyPathEdge(sourceId, targetId) ? 'iso-threat-edge' : 'iso-tree-edge',
      edgeLabel: getEdgeLabel(targetId),
    }
  })

  // 与 data-discovery.vue 对齐：根节点包裹 isRoot: true
  const g6TreeData = attachEdgeLabels(toG6Node(treeData))
  graph.data({ isRoot: true, ...g6TreeData })
  graph.render()
  renderInitiatorTargetEdges()
  bindGraphEvents()

  void nextTick(() => {
    fitViewSafe()
    highlightSelected()
    applyRootPathEdgeStyles()
  })
}

__expose({ refreshGraph })

watch(
  () => props.selectedId,
  () => {
    void nextTick(() => highlightSelected())
  }
)

watch(
  () => props.matchedBusinessId,
  () => {
    void nextTick(() => applyRootPathEdgeStyles())
  }
)

watch(
  () => props.fullscreen,
  (val) => {
    if (!graph) return
    if (val) graph.addBehaviors(['zoom-canvas'], 'default')
    else graph.removeBehaviors(['zoom-canvas'], 'default')
  }
)

onMounted(() => {
  void nextTick(() => {
    refreshGraph()
    if (containerRef.value && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => resizeGraph())
      resizeObserver.observe(containerRef.value)
    }
  })
})

onUnmounted(() => {
  resizeObserver?.disconnect()
  resizeObserver = null
  graph?.destroy()
  graph = null
})

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dropdown, {
        trigger: "click",
        placement: "bottom-start",
        size: "small"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, { class: "graph-legend-menu" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('securityEvent.graphLegendNormalEdge')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('securityEvent.graphLegendKeyPathEdge')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('securityEvent.graphLegendRootPathEdge')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('securityEvent.graphLegendProcess')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('securityEvent.graphLegendThreatEntity')), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('securityEvent.graphLegend')), 1),
            _hoisted_5
          ])
        ]),
        _: 1
      }),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          type: "button",
          class: "graph-toolbar__btn graph-toolbar__btn--icon",
          title: _ctx.$t('securityEvent.graphZoomIn'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (zoom(1.2)))
        }, _hoisted_20, 8, _hoisted_18),
        _createElementVNode("button", {
          type: "button",
          class: "graph-toolbar__btn graph-toolbar__btn--icon",
          title: _ctx.$t('securityEvent.graphZoomOut'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (zoom(0.8)))
        }, _hoisted_23, 8, _hoisted_21),
        _createElementVNode("button", {
          type: "button",
          class: "graph-toolbar__btn graph-toolbar__btn--icon",
          title: _ctx.$t('securityEvent.graphFit'),
          onClick: fitView
        }, _hoisted_26, 8, _hoisted_24),
        _createElementVNode("button", {
          type: "button",
          class: "graph-toolbar__btn graph-toolbar__btn--icon",
          title: _ctx.$t('securityEvent.graphReset'),
          onClick: resetView
        }, _hoisted_29, 8, _hoisted_27)
      ])
    ]),
    (_ctx.assetIp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('securityEvent.graphAffectedAsset')), 1),
          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.computer_name) + " (" + _toDisplayString(_ctx.assetIp) + ")", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "containerRef",
      ref: containerRef,
      class: "process-chain-graph"
    }, null, 512),
    _createElementVNode("div", {
      ref_key: "minimapRef",
      ref: minimapRef,
      class: "process-chain-minimap",
      "aria-hidden": "true"
    }, null, 512)
  ]))
}
}

})